import React from "react";
import { observer } from "mobx-react-lite";
import { useOnboardingFlow } from "./hooks/useOnboardingFlow";
import EmailEntryStep from "./steps/EmailEntryStep";
import OTPEntryStep from "./steps/OTPEntryStep";

/**
 * Main onboarding flow component
 *
 * Renders either the email entry or OTP entry step based on current state.
 * All business logic is handled by the useOnboardingFlow hook.
 */
interface OnboardingFlowProps {
  /** Keep control after sign-in instead of navigating home — see useOnboardingFlow. */
  onAuthed?: () => void;
}

const OnboardingFlow: React.FC<OnboardingFlowProps> = ({ onAuthed }) => {
  const {
    step,
    email,
    loading,
    error,
    resendCooldown,
    handleEmailSubmit,
    handleOTPSubmit,
    handleResendCode,
    handleGoogleSuccess,
    handleGoogleError,
    handleBack,
  } = useOnboardingFlow(onAuthed);

  return (
    <>
      {step === "email" && (
        <EmailEntryStep
          onSubmit={handleEmailSubmit}
          onGoogleSuccess={handleGoogleSuccess}
          onGoogleError={handleGoogleError}
          loading={loading}
          error={error}
        />
      )}
      {step === "otp" && (
        <OTPEntryStep
          email={email}
          onSubmit={handleOTPSubmit}
          onResend={handleResendCode}
          onBack={handleBack}
          loading={loading}
          error={error}
          resendCooldown={resendCooldown}
        />
      )}
    </>
  );
};

export default observer(OnboardingFlow);
